export default {
    searchTerm: '',
    currentEntity: null,
    takerGroup: null,
    currentTaker: null,
};



// WEBPACK FOOTER //
// ./src/store/state.js